export enum SetupHubStatus {
  NEW = "NEW",
  IN_PROGRESS = "IN_PROGRESS",
  SKIPPED = "SKIPPED",
  COMPLETED = "COMPLETED",
}

export enum SetupHubStepCategory {
  BASICS = "basics",
  USER_SECURITY = "userSecurity",
  NETWORK_SECURITY = "networkSecurity",
  ENDPOINT_SECURITY = "endpointSecurity",
}

export enum SetupHubStep {
  INVITE_TEAMMATES = "inviteTeammates",
  CONNECT_CLOUD_APP = "connectCloudApp",
  ADD_PROTECTED_USERS = "addProtectedUsers",
  SETUP_ACCESS_PERMISSIONS = "setupAccessPermissions",
  DEPLOY_ENDPOINT_AGENT = "deployEndpointAgent",
  ACTIVATE_SAT = "activateSat",
  ADD_DEVICE_LABELS = "addDeviceLabels",
  ADD_DEVICE_POSTURE_SETTINGS = "addDevicePostureSettings",
  DEFINE_DEVICE_DATA_MONITORING_RULES = "defineDeviceDataMonitoringRules",
  DEFINE_USER_DATA_MONITORING_RULES = "defineUserDataMonitoringRules",
  CREATE_NETWORK_VIRTUAL_SERVER = "createNetworkVirtualServer",
  SETUP_VPN_ACCESS = "setupVpnAccess",
  CREATE_SWG_VIRTUAL_SERVER = "createSwgVirtualServer",
  ENABLE_DNS_FILTERING = "enableDnsFiltering",
}

export const setupHubSubStepLinks: Record<SetupHubStep, string> = {
  [SetupHubStep.INVITE_TEAMMATES]: "https://docs.coro.net/admin/adduser/#adding-a-new-admin-user",
  [SetupHubStep.CONNECT_CLOUD_APP]: "https://docs.coro.net/cloudappsecurity/connecting/",
  [SetupHubStep.ADD_PROTECTED_USERS]: "https://docs.coro.net/users/users-and-groups/",
  [SetupHubStep.DEPLOY_ENDPOINT_AGENT]: "",
  [SetupHubStep.SETUP_ACCESS_PERMISSIONS]:
    "https://docs.coro.net/cloudappsecurity/policies/#access-permissions",
  [SetupHubStep.DEFINE_USER_DATA_MONITORING_RULES]: "",
  [SetupHubStep.ACTIVATE_SAT]: "https://docs.coro.net/sat/sat-settings/",
  [SetupHubStep.ADD_DEVICE_LABELS]: "https://docs.coro.net/devices/labels/",
  [SetupHubStep.ADD_DEVICE_POSTURE_SETTINGS]: "https://docs.coro.net/endpointsecurity/posture/",
  [SetupHubStep.DEFINE_DEVICE_DATA_MONITORING_RULES]:
    "https://docs.coro.net/endpointdatagov/edg-config/",
  [SetupHubStep.CREATE_NETWORK_VIRTUAL_SERVER]: "https://docs.coro.net/networksettings/activate/",
  [SetupHubStep.SETUP_VPN_ACCESS]: "https://docs.coro.net/network/ztna",
  [SetupHubStep.CREATE_SWG_VIRTUAL_SERVER]: "https://docs.coro.net/swg/overview/",
  [SetupHubStep.ENABLE_DNS_FILTERING]: "https://docs.coro.net/swg/overview/",
};
